<template>
    <div :style="styleString"
        :class="{ 'ai_group': isAIGroup }"
        @mousedown.left.prevent="action_MouseDown"
        @mousemove.left.prevent="action_MouseMove"
        @mouseup.left.prevent="action_MouseUp"
        @mouseup.right.prevent="action_MouseRight"
    >
        <span class="col_title" :title="title" v-if="!isEmpty">
            <span class="ellipsis">{{ title }}</span>
            <button class="rsv_col_add_btn" @click.prevent="action_AddColumn"><v-icon>mdi-plus</v-icon></button>
            <!-- 셀 가로 늘리기 -->
            <div class="col_resize" @mousedown.prevent="action_MouseDownForWidth"></div>
        </span>
        <span class="col_title txt_center" v-if="isEmpty">
            <button class="rsv_col_add_btn no_fix" @click.prevent="action_AddColumn"><v-icon>mdi-plus</v-icon></button>
        </span>
    </div>
</template>


<script>
import { mapState } from 'vuex'
import { sheetState } from '../../../sheet-state'
import { hideCellMenu, hideColumnMenu, hideReservationMenu, showColumnMenu, showColumnSetting } from '../../../sheet-overlays'
import { sheetAxis } from '../../../sheet-axis'
import { columnWidth, startColumnResize } from './column-width'
export default {
    props: {
        groups: Array,
        column: Object,
        xPosition: Number,
        selectedAreaHelper: Object,
        isAIGroup: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            sheetState,
            sheetAxis,
            columnWidth,
        }
    },
    computed: {
        ...mapState(['V2ReservationCellConfig']),
        isEmpty: function() {
            if (this.column?._id == undefined) { return true }
            return false
        },
        title: function() { return this.column.title ?? '-' },
        yLength: function() { return this.sheetAxis.timeArray?.length },
        storedWidthArray: function() { return this.columnWidth.storedWidths },
        widthObject: function() { return this.storedWidthArray.find( w => w._id == this.column._id) },
        width: function() { return this.widthObject?.width ?? 160 },
        styleString: function() { return 'width: ' + this.width + 'px;' },
        selectedRange: function() { return this.selectedAreaHelper.selectedRange },
        startX: function() { return this.selectedRange.start.x > this.selectedRange.end.x ? this.selectedRange.end.x : this.selectedRange.start.x },
        endX: function() { return this.selectedRange.start.x < this.selectedRange.end.x ? this.selectedRange.end.x : this.selectedRange.start.x },
        selectedColumns: function() {
            let columns = []
            for (let i=0 ; i<this.groups.length ; i++) {
                columns = columns.concat(this.groups[i].columns.filter(c => c.isSelected))
            }
            return columns
        },
    },
    methods: {
        action_AddColumn() {
            let index = this.column?.order + 1
            if (this.isEmpty) {
                index = 0
            }
            showColumnSetting( {order: index, groupID: this.column.groupID} )
        },
        action_MouseDown() {
            if (this.columnWidth.isResizing == true) { return }
            hideCellMenu()
            hideReservationMenu()
            this.selectedAreaHelper.setType(this.selectedAreaHelper.Type.column)
            this.selectedAreaHelper.setStartPoint(this.xPosition, 0)
            this.selectedAreaHelper.setEndPoint(this.xPosition, this.yLength-1)
        },
        action_MouseMove() {
            if (this.columnWidth.isResizing == true) { return }
            if (this.selectedAreaHelper == undefined) { return }
            if (this.selectedAreaHelper.startPoint.x == undefined) { return }
            if (this.selectedAreaHelper.currentType != this.selectedAreaHelper.Type.column) { return }
            this.selectedAreaHelper.setEndPoint(this.xPosition, this.yLength-1)
            let start = this.selectedAreaHelper.endPoint
            let end = this.selectedAreaHelper.startPoint
            this.selectedAreaHelper.setSelectedRange(start.x, start.y, end.x, end.y)
        },
        action_MouseUp() {
            if (this.columnWidth.isResizing == true) { return }
            if (this.selectedAreaHelper.currentType == this.selectedAreaHelper.Type.none) { return }
            let start = this.selectedAreaHelper.startPoint
            let end = this.selectedAreaHelper.endPoint
            if (this.selectedAreaHelper.currentType == this.selectedAreaHelper.Type.column) {
                let start = this.selectedAreaHelper.endPoint
                let end = this.selectedAreaHelper.startPoint
                this.selectedAreaHelper.setSelectedRange(end.x, start.y, start.x, end.y)
            }
            else {
                this.selectedAreaHelper.setSelectedRange(start.x, start.y, end.x, end.y)
            }
            this.selectedAreaHelper.clearStartEndPoint()
        },
        action_MouseRight(e) {
            if (this.column._id == undefined) { 
                hideColumnMenu()
                return
            }
            this.action_MouseDown()
            this.action_MouseUp()
            let position = this.getMousePosition(e)
            showColumnMenu(position, this.column)
        },
        getMousePosition(e) {
            let sheetRect = this.sheetState.sheetElement.getBoundingClientRect()
            let scrollRect = this.sheetState.sheetScrollElement
            let x = e.clientX - sheetRect.x + scrollRect.scrollLeft
            let y = e.clientY - sheetRect.y + scrollRect.scrollTop
            return {x: x, y: y}
        },

        action_MouseDownForWidth(e) {
            if (this.startX > this.xPosition || this.endX < this.xPosition ) { this.selectedAreaHelper.clearSelectedRange() }
            startColumnResize(e, this.column._id, { areaHelper: this.selectedAreaHelper, groups: this.groups })
        }
    }
}
</script>

<style scoped>
/* AI 그룹 스타일 */
.ai_group .col_title {
    background-color: #F5F7FF;
    color: #1F8FE5;
}
</style>